import { compose, invoker, map, prop } from 'ramda';

const errorMissingDataConnection =
    'Error: The specified data connection is not present: ';

function dataConnectionExists(dataConnections, domName) {
    if (!domName) {
        return false;
    }

    return dataConnections.exists(domName);
}

export function verifyDataConnectionExists(dataConnections, domName) {
    if (domName && !dataConnectionExists(dataConnections, domName)) {
        throw new Error(errorMissingDataConnection + domName);
    }
}

export function getDataConnection(dataConnections, dsName) {
    verifyDataConnectionExists(dsName);

    return dataConnections.get(dsName);
}

// DataConnectionCollection -> [String]
export const enumerateDataConnections = compose(
    map(prop('name')),
    invoker(0, 'getAll'),
);
